export default __webpack_public_path__ + "66bbb095cb8df1cb4dfad420568ecf4e.png";